module.exports = __webpack_public_path__ + "img/icon-pfeil-link_weiss.26ec5521.svg";